export default __webpack_public_path__ + "static/media/404.83d0942b.jpg";